import { t } from "./t";

/**
 * Exists merely to avoid using `jsdom` to add `localeCompare` in unit tests.
 */
export function localCompareTranslations(first: string, second: string) {
  return t(first).localeCompare(t(second));
}
